export default "__VITE_ASSET__zB3wLAAl__"